import {
  AccordionItem,
  AccordionItemTrigger,
  AccordionRoot,
  AccordionItemContent,
  Text,
  Accordion,
} from '@chakra-ui/react';
import React from 'react';
import { categories } from './categories';
import { SafeLink } from '@/components/ui/SafeLink';

const ExploreProductAccordion = () => {
  return (
    <AccordionRoot display="flex" flexDirection="column" gap={4} multiple>
      {categories.map((category) => (
        <AccordionItem key={category.id} value={category.category}>
          <AccordionItemTrigger
            backgroundColor="#FBF8FF"
            borderRadius="4px"
            _expanded={{
              borderRadius: '4px 4px 0 0',
            }}
            justifyContent="space-between"
            cursor="pointer"
            padding={4}
          >
            <Text color="brand.90" fontWeight="regular" textStyle="body3">
              {category.category}
            </Text>
            <Accordion.ItemIndicator />
          </AccordionItemTrigger>
          <AccordionItemContent
            backgroundColor="#FBF8FF"
            borderRadius="0 0 4px 4px"
            borderTop="1px solid"
            borderTopColor="brand.5"
            display="flex"
            flexDirection={{ base: 'column', tablet: 'row' }}
            flexWrap="wrap"
            gap={4}
            padding={6}
          >
            {category.subCategories.map((subCategory) => (
              <SafeLink href={subCategory.link} key={subCategory.name}>
                <Text _hover={{ color: 'neutral.50' }} color="neutral.80" fontWeight="regular" textStyle="body3">
                  {subCategory.name}
                </Text>
              </SafeLink>
            ))}
          </AccordionItemContent>
        </AccordionItem>
      ))}
    </AccordionRoot>
  );
};

export default ExploreProductAccordion;
